export const LOGGED = 'signin/LOGGED';
export const LOADING = 'signin/LOADING';
export const MESSAGE = 'signin/MESSAGE';